<style scoped>
  .big {
    font-size: 16px;
  }

  .qtyError {
    font-size: 12px;
    color:var(--color-danger-light);
    height: 16px;
    padding-left: 5px;
  }

  .qtyMultiplier {
    text-align: left;
    cursor: pointer;
    padding-left: 10px;
    color: var(--color-info);
  }

  .qtyMultiplier:hover {
    text-decoration: underline;
  }

  td {
     /*border: 1px solid greenyellow;*/
  }

  div {
    /*border: 1px solid lightgray;*/
  }

  .infoCell {
    height: 50px;
    vertical-align: top
  }

  .qtyCell {
    padding-left: 8px;
    font-size: 16px;
    vertical-align: top;
  }

  .numname {
    font-size: 12px;
    color: var(--color-text-dark);
    font-weight: bold;
  }

  .value {
    font-size: 20px;
    /*font-weight: bold;*/
  }

  .currency {
    font-size: 14px;
    color: var(--color-neutral);
  }
</style>

<template>
  <div>
    <Modal :value="show" width="430" @input="$emit('on-cancel', $event)">
      <p slot="header" style=" text-align:center">
        <span class="big">Усреднение сделки</span>
<!--        <span class="big" style="font-size: 16px">УСРЕДНЕНИЕ СДЕЛКИ</span>-->
      </p>
      <div style="font-size: 14px; padding: 8px 5px;">
        <table>
          <tr>
            <td></td>
            <td>
              <span class="qtyMultiplier" @click="multiplyQty(0.5)">0.5x</span>
              <span class="qtyMultiplier" @click="multiplyQty(1)">1x</span>
              <span class="qtyMultiplier" @click="multiplyQty(2)">2x</span>
            </td>
          </tr>
          <tr>
            <td width="30%" style="padding-bottom: 10px">
              КОЛИЧЕСТВО
            </td>
            <td>
              <i-input :value="rebuyQty" @on-keydown="onkeyDown(rebuyQty,$event)"  @on-change="rebuyQtyChanged">
                <span slot="append"><div style="width: 50px; font-size: 14px; color: var(--color-neutral)">{{ qtyAsset }}</div></span>
              </i-input>
              <div class="qtyError">{{ qtyError }}</div>
            </td>
          </tr>
        </table>
        <table style="width: 100%; margin-top: 10px;">
          <tr style="height: 60px; vertical-align: top;">
            <td style="width: 50%">
              <div class="numname">СУММА</div>
              <div class="value">{{ amount }}&nbsp;<span class="currency">{{ currency }}</span></div>
            </td>
            <td style="width: 50%">
              <div class="numname">CРЕДНЯЯ ЦЕНА</div>
              <div class="value">{{ trade.Price }}&nbsp;<span class="currency">{{ currency }}</span></div>
            </td>

          </tr>
          <tr style="vertical-align: top;">
            <td style="width: 50%">
              <div class="numname">СВОБОДНЫЙ БАЛАНС</div>
              <div class="value">{{ balance }}&nbsp;<span class="currency">{{ balanceAsset }}</span></div>
            </td>
            <td style="width: 50%">
              <div class="numname">
                НОВАЯ СРЕДНЯЯ ЦЕНА
                <Tooltip max-width="240" placement="right-start" content="Примерное значение">
                  <Icon style="var(--color-neutral)" type="ios-information-circle-outline"></Icon>
                </Tooltip>
              </div>
              <div class="value">{{ newPrice }}&nbsp;<span class="currency">{{ currency }}</span></div>
            </td>
          </tr>
        </table>
<!--          <tr>
            <td class="infoCell" style="padding-top: 13px; height: 60px">
              Сумма
            </td>
            <td class="qtyCell" style="padding-top: 10px;">
              {{ amount }}&nbsp;<span style="color: var(--color-neutral)">{{ currency }}</span>
            </td>
          </tr>
          <tr>
            <td class="infoCell">
              Свободный баланс
            </td>
            <td class="qtyCell">
              {{ balance }}&nbsp;<span style="color: var(--color-neutral)">{{ balanceAsset }}</span>
            </td>
          </tr>
          <tr>
            <td class="infoCell">
              Новая средняя цена
              <Tooltip max-width="240" placement="right-start" content="Примерная">
                <Icon style="color: var(--color-neutral)" type="ios-information-circle-outline"></Icon>
              </Tooltip>
            </td>
            <td class="qtyCell">
              {{ newPrice }}&nbsp;<span style="color: var(--color-neutral)">{{ currency }}</span>
            </td>
          </tr>
        </table> -->
      </div>
      <div slot="footer">
        <Button :loading="loading" @click="rebuy" long size="large" :disabled="qtyError !== '' || loading">{{ confirmBtnText }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Decimal from 'decimal.js'
import Api from '@/util/api'
import Constants from '@/util/constants'
import terminal from '@/services/terminal'

export default {
  name: 'ConfirmRebuyModal',
  props: ['show', 'trade'],
  data () {
    return {
      lastPrice: '0',
      balance: '0',
      amount: '0',
      loading: false,
      newPrice: '0',
      rebuyQty: '0',
      qtyError: ''
    }
  },
  watch: {
    'trade': function () {
      this.qtyError = ''
      if (this.trade.QtyNofee) {
        this.rebuyQty = this.trade.QtyNofee
        this.updateBalance()
      }
    }
  },
  computed: {
    balanceAsset () {
      if (this.trade.Side) {
        if (this.trade.Side === 'B') {
          return this.currency
        } else {
          return this.qtyAsset
        }
      }
      return ''
    },
    confirmBtnText () {
      let text = ''
      if (this.trade.Side) {
        if (this.trade.Side === 'B') {
          text = 'Купить '
        } else {
          text = 'Продать '
        }
      }
      text += this.qtyAsset + ' по рынку'
      return text
    },
    currency () {
      if (this.trade.Symbol) {
        const assets = this.trade.Symbol.split('_')
        if (assets.length > 0) {
          return assets[1]
        }
      }
      return ''
    },
    qtyAsset () {
      // console.log(this.trade)
      if (this.trade.Symbol) {
        const assets = this.trade.Symbol.split('_')
        if (assets.length > 0) {
          return assets[0]
        }
      }
      return ''
    }
  },
  methods: {
    updateBalance () {
      Api.get('asset/balance', {
        params: {
          token: this.$store.state.sys.token,
          etid: this.trade.ExchTokenId,
          symbol: this.trade.Symbol
        }
      }).then(response => {
        if (response.status === Constants.http.OK) {
          // console.log('ok. data: ', response.data)
          if (response.data) {
            this.balance = response.data.QAssetFree
            if (this.trade.Side === 'S') {
              this.balance = response.data.BAssetFree
            }
            this.lastPrice = response.data.LastPrice
            this.updatePrice()
            this.updateAmount()
            this.checkErrs()
          }
          if (response.data.err) {
            this.qtyError = response.data.err
          }
        } else {
          console.log('error. status: ', response.status)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    updateAmount () {
      if (this.rebuyQty === '' || this.rebuyQty === '0') {
        this.amount = '0'
        return
      }
      const qty = new Decimal(this.rebuyQty).mul(this.lastPrice)
      this.amount = qty.toString()
    },
    onkeyDown (txt, e) {
      if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
          // Allow: Ctrl+A
          (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl+C
          (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl+V
          (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl+X
          (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: home, end, left, right
          (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return
      }
      if (e.keyCode === 190) {
        if (txt.includes('.')) {
          e.preventDefault()
        } else {
          return
        }
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    },
    rebuyQtyChanged (e) {
      // console.log(this.rebuyQty)
      this.rebuyQty = e.target.value.replace('ю', '.').replace(/[^\d.-]/g, '')
      if (this.rebuyQty.charAt(0) === '0' && this.rebuyQty.charAt(1) !== '.') {
        this.rebuyQty = this.rebuyQty.substring(1)
      }
      if (this.rebuyQty === '' || this.rebuyQty === '0') {
        this.rebuyQty = '0'
      }
      this.updatePrice()
      this.updateAmount()
      this.checkErrs()
    },
    checkErrs () {
      const amount = new Decimal(this.amount)
      const qty = new Decimal(this.rebuyQty)
      const balance = new Decimal(this.balance)
      if (this.trade.Side === 'B') {
        if (amount.greaterThan(balance)) {
          this.qtyError = 'Недостaточно средств'
          return
        } else {
          this.qtyError = ''
        }
      } else if (this.trade.Side === 'S') {
        if (qty.greaterThan(balance)) {
          this.qtyError = 'Недостaточно средств'
          return
        } else {
          this.qtyError = ''
        }
      }

      const filt = this.$store.state.data.symbolsfilter[this.trade.Symbol]
      if (!filt) {
        return
      }
      if (new Decimal(this.rebuyQty).lessThan(filt.QtyMin)) {
        this.qtyError = 'Минимальное кол-во: ' + filt.QtyMin
      } else if (new Decimal(this.rebuyQty).mul(this.lastPrice).lessThan(filt.AmountMin)) {
        this.qtyError = 'Минимальная сумма: ' + filt.AmountMin
      } else if (this.numAfterDot(this.rebuyQty) > filt.QtyDec) {
        this.qtyError = 'Максимальное число знаков после запятой: ' + filt.QtyDec
      } else {
        this.qtyError = ''
      }
    },
    numAfterDot (numb) {
      if (typeof numb === 'number') {
        numb = numb.toString()
      }
      if (!numb.includes('.')) {
        return 0
      } else {
        return numb.split('.')[1].length
      }
    },
    rebuy () {
      if (this.rebuyQty !== '0') {
        this.loading = true
        Api.get('trade/rebuy', {
          params: {
            token: this.$store.state.sys.token,
            trid: this.trade.Id,
            qty: this.rebuyQty
          }
        }).then(response => {
          if (response.status === Constants.http.OK) {
            // console.log('ok. data: ', response.data)
            if (response.data.status) {
              if (response.data.status === 'ok') {
                this.$store.dispatch('updateTrades')
                this.$emit('rebought')
                this.$Notice.success({
                  title: 'Приказ создан',
                  duration: 3
                })
                if (this.$store.state.trade.editTrade) {
                  terminal.tradeGetAndSet(this.$store.state.trade.editTrade.Id)
                }
              }
            }
            if (response.data.err) {
              this.qtyError = response.data.err
              this.$store.dispatch('updateExchangesAsync')
            }
          } else {
            console.log('error. status: ', response.status)
          }
          this.loading = false
        }).catch(error => {
          console.log(error)
          this.loading = false
        })
      }
    },
    updatePrice () {
      if (this.rebuyQty === '' || this.rebuyQty === '0' || this.rebuyQty === '0.') {
        this.newPrice = this.trade.Price
        return
      }
      // console.log('rebuy trade:', this.trade)
      const tradeAmount = new Decimal(this.trade.Qty).mul(this.trade.Price)
      const rebuyAmount = new Decimal(this.rebuyQty).mul(this.lastPrice)
      const sumQty = new Decimal(this.rebuyQty).add(this.trade.QtyNofee)
      const priceDec = this.$store.state.data.symbolsfilter[this.trade.Symbol].PriceDec
      this.newPrice = tradeAmount.add(rebuyAmount).div(sumQty).toDP(priceDec, Decimal.ROUND_DOWN).toString()
    },
    multiplyQty (multiplier) {
      if (this.trade.QtyNofee) {
        const qtyDec = this.$store.state.data.symbolsfilter[this.trade.Symbol].QtyDec
        let newQty = new Decimal(this.trade.QtyNofee).mul(multiplier)
        if (qtyDec) {
          newQty = newQty.toDP(qtyDec, Decimal.ROUND_DOWN)
        }
        this.rebuyQty = newQty.toString()
        this.updatePrice()
        this.updateAmount()
        this.checkErrs()
      }
    }
  }
}
</script>
